import tableCarrier from './config.carrier';
import tableShipper from './config.shipper';

export default function load(session) {
  return session?.client?.type === 'carrier' ? tableCarrier : tableShipper
};